import { render, staticRenderFns } from "./chat-message-video.vue?vue&type=template&id=1e38a95c&scoped=true"
import script from "./chat-message-video.vue?vue&type=script&lang=js"
export * from "./chat-message-video.vue?vue&type=script&lang=js"
import style0 from "./chat-message-video.vue?vue&type=style&index=0&id=1e38a95c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e38a95c",
  null
  
)

export default component.exports